import { Button, Grid } from "@mui/material";
import { useSuperAdminPermissions } from "../../../../context/SuperAdmin/PermissionContext";
import { useAuthContext } from "../../../../hooks/Auth";

const HeadersRolePermissions = () => {
  const { openModal, selectedPermissions, toggleDeleteModal } =
    useSuperAdminPermissions();
    const { canAccess } = useAuthContext();
    
  return (
    <Grid container spacing={4} display={"flex"} justifyContent={"flex-end"}>
      {canAccess("delete:roleApps") && <Grid item>
        <Button
          variant="outlined"
          onClick={() => toggleDeleteModal(true)}
          disabled={!selectedPermissions.length}
          sx={{
            borderRadius: 14,
            border: "1px solid #336B87",
            color: "#336B87",
            "&:hover": {
              backgroundColor: "#336B87",
              color: "#EEF3F6",
            },
          }}
        >
          Eliminar
        </Button>
      </Grid>}
      {canAccess("create:roleApps") && <Grid item>
        <Button
          variant="contained"
          onClick={openModal}
          sx={{ background: "#336B87" }}
        >
          Agregar UmmIApps
        </Button>
      </Grid>}
    </Grid>
  );
};

export default HeadersRolePermissions;
